import angular from 'angular';
import TermsConfirmDialogComponent from './terms-confirm-dialog-component';


export default angular
  .module('terms-confirm-dialog', [])
  .component('termsConfirmDialog', new TermsConfirmDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-confirm-dialog/terms-confirm-dialog-module.js